import axios from "axios";
import {
  GET_PEOPLE_RECOMMENDATIONS_URL,
  POST_RECOMMENDATIONS_FEEDBACK_URL,
} from "../constants";

export const fetchPeopleRecommendationsApi = async (token, { limit, cursor }) => {
  const response = await axios.get(
    GET_PEOPLE_RECOMMENDATIONS_URL({ limit, cursor }),
    {
      headers: {
        authorization: token,
      },
    }
  );
  return response.data;
};

export const sendRecommendationFeedbackApi = async (token, payload) => {
  await axios.post(POST_RECOMMENDATIONS_FEEDBACK_URL, payload, {
    headers: {
      authorization: token,
    },
  });
};
